import React, {useMemo} from 'react';
import { styles as skeletonStyles } from "@material-ui/lab/Skeleton/Skeleton";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  ...skeletonStyles(theme),
  noMargins: {
    '& *': {
      margin: '0',
    }
  },
  hfit: {
    height: 'fit-content',
  },
  wfull: {
    width: '100%'
  },
  flex: {
    display: 'flex'
  }
}));

// Skeleton sem rerenderizar as children, com transparência e "tight-fit".
export default function Skeleton({ children, shouldDisplayChildren, variant = "rect", transparent = false, tightFit = true }) {
  const classes = useStyles();
  
  const variantClass = useMemo(() => {
    switch (variant) {
      case "rect":
        return classes.rect
      case "circle":
        return classes.circle
      case "text":
        return classes.text
      default:
        return classes.rect
    }
  }, [variant, classes]);
  
  const hiddenChildrenClasses = useMemo(() => `${classes.root} ${transparent ? '' : classes.withChildren} ${classes.pulse} ${classes.wave} `, [classes, transparent]);
  
  return (
    <div className={`${ shouldDisplayChildren ? '' : hiddenChildrenClasses} ${tightFit ? classes.noMargins : ''} ${variantClass}  ${classes.hfit} ${classes.wfull} ${classes.flex}`}
         onClick={event => { if (!shouldDisplayChildren && event.stopImmediatePropagation) { event.stopImmediatePropagation(); } }}
    >
      {children}
    </div>
  );
}